










































import Vue, { PropType } from 'vue';
import {
  Configuration,
  ConfigurationAnswer,
  ConfigurationItem
} from '@/models/configurator/configuration';
import { Module } from '@/models/configurator/module';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'ProductBuilderCard',
  props: {
    module: {
      type: Object as PropType<Module>
    },

    configuration: {
      type: Object as PropType<Configuration>,
      required: true
    },

    snapshot: {
      type: Number as PropType<number>
    },

    exchangeRate: Number,
    currencyCode: String
  },

  data: () => ({
    configurationItems: [] as ConfigurationItem[],
    configurationAnswers: [] as ConfigurationAnswer[],
    configurationLoading: false
  }),

  methods: {
    ...mapActions({
      fetchConfigurationItems:
        'configuratorConfiguration/fetchConfigurationItems',

      fetchConfigurationAnswers:
        'configuratorConfiguration/fetchConfigurationAnswers'
    }),

    async getConfigurationData() {
      this.configurationLoading = true;

      await this.fetchConfigurationAnswers(this.configuration.id).then(
        answerList => {
          this.configurationAnswers = answerList;
        }
      );

      await this.fetchConfigurationItems(this.configuration.id).then(
        itemList => {
          this.configurationItems = itemList;
        }
      );

      this.configurationLoading = false;
    },

    save(val: boolean) {
      this.$emit('save', val);
    }
  },

  mounted() {
    this.getConfigurationData();
  }
});
